import { Router, ActivatedRoute } from '@angular/router';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ConnectionService } from '../../../../services/connection-service';
import { AppConfig } from '../../../app.config';
import { WindowRefService } from '../../../../services/window-ref-service';

@Component({
  selector: 'product-collections-list',
  templateUrl: './product-collections-list.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AgGridAngular
  ]
})
export class ProductCollectionsListComponent implements OnInit, OnDestroy {
  data: any = [];
  length: number = 0;
  gridApi: GridApi;
  dataSource: any;
  window: any;
  components: any;
  ui: any = {};
  columnDefs: any;
  searchKey: string;

  constructor(
    private router: Router,
    private conn: ConnectionService,
    private zone: NgZone,
    public appConfig: AppConfig,
    public windowRef: WindowRefService,
    private route: ActivatedRoute
  ) {
    this.window = windowRef.nativeWindow;
  }

  ngOnInit(): void {
    this.listViewSetup();
  }

  listViewSetup(): any {
    this.ui = { grid: { rowModelType: 'infinite', pageSize: 100 } };
    this.setUpGrid();
  }

  setUpGrid(): void {
    this.dataSource = {
      rowCount: null,
      getRows: (params: any): void => {
        this.loadMore()
          .then((data: Array<any>) => {
            if (params.startRow === 0 && !data.length) this.gridApi.showNoRowsOverlay();
            else this.gridApi.hideOverlay();
            params.successCallback(data, data.length === this.ui.grid.pageSize ? -1 : params.startRow + data.length);
          });
      },
    };
    this.components = {
      loadingRenderer(params: any): any {
        if (params.value) return params.value;
        return '';
      },
    };
    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'objectId',
        width: 150,
        pinned: 'left',
        cellRenderer: (params: any): any => {
          if (!params.data) {
            const eDiv = this.window.document.createElement('div');
            eDiv.innerHTML = 'Loading ...';
            return eDiv;
          }
          const eDiv = this.window.document.createElement('div');
          const id = params.value || params.data.objectId;
          eDiv.innerHTML = `<a class='col-xs-12 no-padder ellipsis' href='#'>${id}</a>`;
          return eDiv;
        },
      },
      {
        headerName: 'Edit',
        width: 50,
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const url = this.router.url.split('/');
          url.splice(url.length - 1, 1);
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = `<a class='fa fa-pencil-square-o' href='${url.join('/')}/name/${params.data?.name}'></a>`;
          return eDiv;
        },
      },
      {
        headerName: 'Name',
        field: 'name',
        width: 200,
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const data = params.value || params.data.name || '';
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = `<span>${data}</span>`;
          return eDiv;
        },
      },
      {
        headerName: 'Priority',
        field: 'priority',
        width: 100,
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const data = params.value || params.data.priority || '';
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = `<span>${data}</span>`;
          return eDiv;
        },
      },
      {
        headerName: 'Created At',
        field: 'createdAt',
        width: 150,
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const data = params.value || params.data.createdAt;
          if (!data) return '';
          const eDiv = this.window.document.createElement('div');
          const date = new Date(data);
          eDiv.innerHTML = `<span>${date.toLocaleDateString()}</span>`;
          return eDiv;
        },
      },
    ];
  }

  reset(): void {
    if (!this.gridApi) return;
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

  resetFilters(): void {
    delete this.searchKey;
    this.reset();
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridApi.setGridOption('defaultColDef', { width: 120 });
    this.gridApi.setGridOption('columnDefs', this.columnDefs);
    this.gridApi.setGridOption('cacheBlockSize', this.ui.grid.pageSize);
    this.gridApi.setGridOption('animateRows', true);
    this.gridApi.setGridOption('datasource', this.dataSource);
    this.reset();
  }

  async loadMore(): Promise<any> {
    try {
      const sessionToken = this.conn.getCurrentUser().getSessionToken();
      const { data } = await this.conn.serverApi.getAllProductCollections(sessionToken);
      return data.productCollections;
    } catch (error) {
      return [];
    }
  }

  ngOnDestroy(): void {
    delete this.conn;
    delete this.zone;
    delete this.data;
    delete this.ui;
  }
}

